export var borderColor = 'var(--_1jljrbf1-3-15-1)';
export var rangeColor = 'var(--_1jljrbf0-3-15-1)';